<template>
    <div>
        <div class="mx-auto max-w-7xl">
            <div :class="{'flex justify-end pr-4 sm:pr-0 gap-4': !alignLeft, 'flex justify-start sm:pl-0 gap-4': alignLeft}">
                <slot />
            </div>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        alignLeft: {
            type: Boolean,
            default: false
        }
    }
}
</script>